import { useMutation, MutationKey } from "react-query";
import Axios from "axios";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { VehicleInventory } from "../../../components/FleetManagement/types/VehicleInventory.types";

type UpdateFleetPayload = { id: number; formData: FormData };

export function useRemoteUpdateFleet() {
  const { t } = useTranslation();
  const snackbar = useSnackbar();

  return useMutation<VehicleInventory, RemoteApiError, UpdateFleetPayload>(
    ["fleet", "update"] as MutationKey,
    async ({ id, formData }: UpdateFleetPayload): Promise<VehicleInventory> => {
      try {
        const response = await Axios.patch<VehicleInventory>(`/fleet/vehicles/${id}`, formData);
        snackbar.enqueueSnackbar(t("Successfully updated vehicle"), { variant: "success" });
        return response.data;
      } catch (error) {
        snackbar.enqueueSnackbar(t("There was a server error"), { variant: "error" });
        throw error;
      }
    }
  );
}
